<template>
  <div class="home">
    <navbar>
      <div class="d-flex">
        <div class="mx-2">
          <input
            type="text"
            id="search"
            v-model="search"
            placeholder="Search"
            class="form-control form-control-sm"
          />
        </div>
        <!-- <div class="mx-2">
          <input
            type="text"
            size="4"
            id="searchId"
            v-model="searchId"
            placeholder="ID"
            class="form-control form-control-sm"
          />
        </div> -->
        <div class="">
          <button
            @click="exportAllPdfs"
            class="btn btn-sm btn-outline-light me-2"
            :disabled="exporting"
          >
            <span v-if="exporting">
              <i class="fa fa-spinner fa-pulse"></i> Exporting...
            </span>
            <span v-else>
              <i class="fa fa-download"></i> Export PDFs
            </span>
          </button>
          <router-link
            to="/admin/products"
            class="btn btn-sm btn-outline-light"
          >
            Admin
          </router-link>
        </div>
      </div>
    </navbar>
    <container>
      <div
        class="alert alert-info mt-3 shadow-sm lead text-center"
        v-if="loading"
        v-text="loading"
      ></div>
      <div class="alert alert-info mt-3 shadow-sm" v-if="loads.length">
        <p class="lead">fetching {{ loads.length }} files</p>
        <!-- <ul>
          <li v-for="(load, idx) of loads" :key="idx" v-html="load.name"></li>
        </ul> -->
      </div>
      <div class="list-group shadow-sm my-3" v-if="match.length">
        <router-link
          class="list-group-item list-group-item-action border-primary"
          v-for="product of match"
          :to="`/p/${product.id}`"
          :key="product.id"
        >
          <sds-product :product="product" :search="search"></sds-product>
        </router-link>
      </div>

      <div class="list-group shadow-sm my-3">
        <router-link
          class="list-group-item list-group-item-action"
          v-for="product of filtered"
          :to="`/p/${product.id}`"
          :key="product.id"
        >
          <sds-product :product="product"></sds-product>
        </router-link>
      </div>
    </container>
    <div class="mt-auto mb-2">
      <div v-if="error" class="alert alert-warning mb-2" v-text="error"></div>
      <div class="d-flex justify-content-between">
        <button class="btn btn-sm btn-link" @click="clearCache">
          Reset Catalog
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import SdsProduct from "../components/SdsProduct.vue";
import { get } from "lodash";

export default {
  components: { SdsProduct },
  name: "Home",
  data: () => ({
    products: [],
    keys: [],
    search: "",
    error: null,
    loading: null,
    loads: [],
    exporting: false,
  }),
  computed: {
    filtered() {
      if (this.search.length > 1) {
        return this.products.filter((p) => {
          return JSON.stringify([
            p.name,
            p.code,
            p.local_name,
            get(p, "manufacturer.name", ""),
            get(p, "vendor.name", ""),
            get(p, "location.name", ""),
          ])
            .toLowerCase()
            .includes(this.search.toLowerCase());
        });
      } else {
        return this.products;
      }
    },
    match() {
      if (this.search.length > 1) {
        return this.products.filter((p) => {
          return p.local_id == this.search || p.sds_number == this.search;
        });
      }
      return [];
    },
  },
  methods: {
    async load() {
      document.title = "Products | c3s";
      const productsVersionRemote = await this.getRemoteVersion("products");
      const productsVersionLocal = await this.getLocalVersion("products");
      
      // Always fetch at least first page to verify we have complete data
      if (productsVersionRemote > productsVersionLocal || this.$store.state.products.length === 0) {
        this.products = []; // Reset to ensure clean fetch
        await this.update("products", productsVersionRemote);
      } else {
        // Even if versions match, verify we have complete data by checking first page
        const { data } = await this.axios.get(`/api/products.json?page=1`);
        const expectedTotal = data.pager.Products.totalCount;
        if (this.$store.state.products.length !== expectedTotal) {
          this.products = []; // Reset to ensure clean fetch
          await this.update("products", productsVersionRemote);
        } else {
          this.products = this.$store.state.products;
        }
      }
      this.cacheFiles();
    },
    async clearCache() {
      try {
        const productsVersionRemote = await this.getRemoteVersion("products");
        if (productsVersionRemote) {
          this.$vlf.clear().then(() => {
            this.load();
          });
        } else {
          this.error = "You must be online to reset the catalog.";
          setTimeout(() => {
            this.error = null;
          }, 3000);
        }
      } catch (error) {
        return false;
      }
    },
    cacheFiles() {
      this.$vlf.keys().then((keys) => {
        this.products.forEach((p) => {
          this.cacheFile("sds", p, keys);
          this.cacheFile("eds", p, keys);
        });
      });
    },
    cacheFile(type, p, keys) {
      const key = `files-${type}-${p.id}-${p[type + "_hash"]}`;
      keys
        .filter((k) => {
          return k.includes(`files-${type}-${p.id}-`) && k !== key;
        })
        .map((k) => this.$vlf.removeItem(k));

      this.$vlf.getItem(key).then((res) => {
        if (!res && p[type]) {
          this.loads.push(p);
          const name = encodeURIComponent(p[type].split("/", 2)[1]);
          this.axios({
            url: `/api/products/files/${type}/${name}`,
            method: "POST",
            responseType: "blob",
          }).then((res) => {
            this.$vlf.setItem(key, res.data);
            let idx = this.loads.indexOf(p);
            this.loads.splice(idx, 1);
          });
        }
      });
    },
    async getRemoteVersion(type) {
      try {
        const { data } = await this.axios.get(`/api/${type}/version.json`);
        return data;
      } catch (error) {
        return false;
      }
    },
    async getLocalVersion(type) {
      const data = await this.$vlf.getItem(`data-${type}-version`);
      return data;
    },
    async update(type, version, page = 1) {
      try {
        const { data } = await this.axios.get(`/api/${type}.json?page=${page}`);
        const tbl = _.startCase(type);
        this[type] = this[type].concat(data[tbl]);
        if (data.pager[tbl].nextPage) {
          await this.update(type, version, data.pager[tbl].page + 1);
        } else {
          this.$store.dispatch(`set_${type}`, this[type]);
          this.$vlf.setItem(`data-${type}-version`, version);
        }
        return data[tbl];
      } catch (error) {
        // console.log(error);
        return [];
      }
    },
    async checkForId(id) {
      let prod = this.$store.getters.products.find((p) => p.id == id);
      if (prod) {
        let test = await this.$vlf.getItem(`files-sds-${id}-${prod.sds_hash}`);
        if (test) {
          return this.$router.push(`/p/${id}`);
        }
      }
      setTimeout(() => {
        this.loading += ".";
        this.checkForId(id);
      }, 1000);
    },
    async exportAllPdfs() {
      this.exporting = true;
      try {
        const JSZip = (await import('jszip')).default;
        const zip = new JSZip();
        
        const keys = await this.$vlf.keys();
        const pdfKeys = keys.filter(key => key.startsWith('files-') && (key.includes('-sds-') || key.includes('-eds-')));
        
        let exportedCount = 0;
        let failedCount = 0;
        
        // Use store products instead of local products array
        const allProducts = this.$store.state.products.length > 0 ? this.$store.state.products : this.products;
        
        for (const key of pdfKeys) {
          try {
            const blob = await this.$vlf.getItem(key);
            if (blob) {
              // Extract filename from key
              // Key format: files-{type}-{id}-{hash}
              const parts = key.split('-');
              const type = parts[1]; // 'sds' or 'eds'
              const id = parts[2];  // product id
              const product = allProducts.find(p => p.id == id);
              
              if (product) {
                // Create safe filename
                const safeCode = (product.code || product.name || 'unknown').replace(/[^a-zA-Z0-9_-]/g, '_');
                const filename = `${safeCode}_${type.toUpperCase()}.pdf`;
                zip.file(filename, blob);
                exportedCount++;
              } else {
                // Fallback filename if product not found
                const filename = `product_${id}_${type.toUpperCase()}.pdf`;
                zip.file(filename, blob);
                exportedCount++;
              }
            }
          } catch (error) {
            console.error(`Failed to export ${key}:`, error);
            failedCount++;
          }
        }
        
        if (exportedCount === 0) {
          this.error = "No PDFs found in local storage. Make sure to view products first to cache their PDFs.";
          setTimeout(() => {
            this.error = null;
          }, 5000);
          this.exporting = false;
          return;
        }
        
        const content = await zip.generateAsync({ type: 'blob' });
        const url = URL.createObjectURL(content);
        const link = document.createElement('a');
        link.href = url;
        link.download = `c3s_pdfs_export_${new Date().toISOString().split('T')[0]}.zip`;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        URL.revokeObjectURL(url);
        
        if (failedCount > 0) {
          this.error = `Exported ${exportedCount} PDFs successfully. ${failedCount} files failed to export.`;
          setTimeout(() => {
            this.error = null;
          }, 5000);
        }
        
      } catch (error) {
        console.error('Export failed:', error);
        this.error = "Failed to export PDFs. Please try again.";
        setTimeout(() => {
          this.error = null;
        }, 5000);
      } finally {
        this.exporting = false;
      }
    },
  },
  async mounted() {
    if (this.$route.query.to) {
      // this.loading = "Loading data.";
      return this.$router.push(`/p/${this.$route.query.to}?load=force`);
    }

    this.products = this.$store.state.products;
    this.load();
  },
};
</script>
